import { effect, Injectable, signal, untracked, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { AModel } from '../../models/resources/a-model';
import { AResourceService } from '../resources/a-resource.service';

@Injectable({
  providedIn: 'root'
})
export class ConcreteResourceService<M extends AModel> {
  model = signal<M | null>(null);
  resourceService = signal<AResourceService<M> | null>(null);
  isConcreteSubPage = signal<boolean>(false);
  modelId = signal<number | null>(null);
  modelIdFromUrl: number | undefined;
  currentUrl: string | undefined;
  urlSegments: string[] | undefined;

  constructor(private router: Router) {
    effect(() => {
      if (!this.resourceService())
        return;
      const currentConcreteModel = this.resourceService()!.currentConcreteModel();
      const foundModel = this.resourceService()!.models().find((o: any) => o.id === (this.modelId() ?? this.modelIdFromUrl));

      untracked(() => {
        if (currentConcreteModel != null && this.model() !== currentConcreteModel) {
          this.model.set(currentConcreteModel);
        } else if (foundModel != null && this.model() !== foundModel) {
          this.model.set(foundModel);
        }
      });
    });
  }

  // MUST BE CALLED IN CONSTRUCTOR WHEN INJECTING THIS SERVICE!
  setData(resourceService: any, modelId: number | null = null, isConcreteSubPage: boolean = false) {
    this.model.set(null);
    this.resourceService.set(null);
    this.isConcreteSubPage.set(isConcreteSubPage);

    this.currentUrl = this.router.url;
    this.urlSegments = this.currentUrl.split('/');
    this.modelIdFromUrl = +this.urlSegments[this.isConcreteSubPage() ? this.urlSegments.length - 3 : this.urlSegments.length - 1]; // Get the last segment

    this.modelId.set(modelId);
    this.isConcreteSubPage.set(isConcreteSubPage);
    this.resourceService.set(resourceService);
  }

  getModel(): WritableSignal<any> {
    return this.model;
  }
}
